

import React, { useState, useEffect, useContext } from "react";
import "../css/Profile.css";
import PostDetail from "../components/PostDetail";
import ProfilePic from "../components/ProfilePic";
import { toast } from "react-toastify";
import { LoginContext } from "../context/LoginContext";
import { formatFollowerCount } from "../utils/formatFollowers";
import FollowersModal from "../components/FollowersModal";
import FollowingModal from "../components/FollowingModal";

export default function Profile() {
  const picLink =
    "https://cdn-icons-png.flaticon.com/128/1177/1177568.png";

  const [pic, setPic] = useState([]);
  const [show, setShow] = useState(false);
  const [posts, setPosts] = useState([]);
  const [selectedPost, setSelectedPost] = useState(null);
  const [user, setUser] = useState({});
  const [changePic, setChangePic] = useState(false);

  const [isEditing, setIsEditing] = useState(false);
  const [newBio, setNewBio] = useState("");
  const [newInterests, setNewInterests] = useState("");
  const [newAbout, setNewAbout] = useState("");
  const [newAboutCount, setNewAboutCount] = useState(0);
  const [showAboutModal, setShowAboutModal] = useState(false);
  const [showFollowersModal, setShowFollowersModal] = useState(false);
  const [showFollowingModal, setShowFollowingModal] = useState(false);

  // Emoji filtering helpers (local): prefer Unicode property escape; fallback to surrogate-pair check
  const containsEmoji = (s) => {
    if (!s) return false;
    try {
      return /\p{Emoji}/u.test(s);
    } catch (e) {
      return /[\uD800-\uDBFF][\uDC00-\uDFFF]/.test(s);
    }
  };

  const sanitizeInput = (s) => {
    if (!s) return '';
    try {
      return s.replace(/\p{Emoji}/gu, '');
    } catch (e) {
      return s.replace(/[\uD800-\uDBFF][\uDC00-\uDFFF]/g, '').replace(/[\u2600-\u26FF\u2700-\u27BF]/g, '');
    }
  };

  const { setModalOpen } = useContext(LoginContext);
  const navigate = require('react-router-dom').useNavigate();

  const toggleDetails = (post) => {
    if (show) {
      setShow(false);
      setSelectedPost(null);
    } else {
      setShow(true);
      setSelectedPost(post);
    }
  };

  const changeprofile = () => {
    setChangePic(!changePic);
  };

  const startEditing = () => {
    setNewBio(user.bio || "");
    setNewInterests(user.interests || "");
    setNewAbout(user.about || "");
    setNewAboutCount((user.about || "").length);
    setIsEditing(true);
  };

  const cancelEditing = () => {
    setIsEditing(false);
  };

  const saveProfile = () => {
    if (!newBio.trim()) {
      toast.error("Bio field cannot be empty");
      return;
    }
    if (newAbout && newAbout.length > 1000) { toast.error('About cannot exceed 1000 characters'); return; }

    fetch(`/user/${user._id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("jwt"),
      },
      body: JSON.stringify({
        bio: newBio,
        about: newAbout,
        interests: newInterests, // ✅ plural
      }),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.error) {
          toast.error(result.error);
        } else {
          setUser(result.user);
          setIsEditing(false);
          toast.success("Profile updated successfully");
        }
      })
      .catch((err) => {
        toast.error("Something went wrong");
        console.error(err);
      });
  };

  useEffect(() => {
    fetch(`/user/${JSON.parse(localStorage.getItem("user"))._id}`, {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("jwt"),
      },
    })
      .then((res) => res.json())
      .then((result) => {
        setPic(result.posts);
        setUser(result.user);
      });
  }, []);

  const formatBio = (bio) => {
    return { __html: bio ? bio.replace(/\n/g, "<br />") : "" };
  };

  return (
    <div className="profile">
      <div className="profile-frame">
        <div className="profile-pic">
          <img
            onClick={changeprofile}
            src={user?.Photo ? user.Photo : picLink}
            alt=""
          />
        </div>

        <div className="profile-data">
          <div className="profile-header">
            <div style={{display:'flex',alignItems:'center',gap:12}}>
              <h1 style={{"margin-top": "7px"}} className="username">{user.name}</h1>
            </div>
            <div className="header-actions">
              {/* options button removed from inline header; now shown fixed at top-right */}
            </div>
          </div>

          {/* Fixed top-right options button (three-line / menu icon) */}
          <button
            id="options_btn"
            className="profile-page-options"
            onClick={() => navigate('/profile/options')}
            aria-label="Profile options"
          >
            <span style={{"margin-right": "-14px", "margin-top": "-15px"}} className="material-symbols-outlined">menu</span>
          </button>

          {isEditing ? (
            <>
              <label style={{display:'block',marginBottom:6,fontWeight:600}}>Bio</label>
              <textarea
                className="mainInputs"
                placeholder="Edit bio..."
                value={newBio}
                onChange={(e) => setNewBio(e.target.value)}
                maxLength={130}
                style={{minHeight:80}}
              />
              <div style={{textAlign:'right',fontSize:12,color:'#666'}}>{newBio.length}/130</div>

              <label style={{display:'block',marginBottom:6,fontWeight:600}}>Interests</label>
              <textarea
                className="mainInputs"
                placeholder="Enter interests (comma separated)"
                value={newInterests}
                onChange={(e) => setNewInterests(e.target.value)}
                maxLength={80}
              />

              <div style={{marginTop:8}}>
                <label style={{display:'block',marginBottom:6,fontWeight:600}}>About</label>
                <textarea
                  className="mainInputs"
                  placeholder="Tell people about yourself"
                  value={newAbout}
                  onChange={(e) => { setNewAbout(e.target.value); setNewAboutCount(e.target.value.length); }}
                  maxLength={1000}
                  style={{minHeight:160,width:'100%'}}
                />
                <div style={{textAlign:'right',fontSize:12,color:'#666'}}>{newAboutCount}/1000</div>
              </div>

              <button style={{"margin-right": "10px", "border-radius": "10px", "background-color": "#9e9ee5", "font-weight": "600", "color": "black", "font-size": "15px"}} onClick={saveProfile}>Save</button>
              <button onClick={cancelEditing} style={{"margin-right": "10px", "border-radius": "10px", "background-color": "#67a767", "font-weight": "600", "color": "black", "font-size": "15px"}}>Cancel</button>
            </>
          ) : (
            <>
              <p
                dangerouslySetInnerHTML={formatBio(user?.bio)}
              ></p>
              <p>
                <strong style={{color:"yellow"}}>Interests: </strong>
                <span style={{color: "white", textShadow: "0 0 10px blue, 0 0 20px blue, 0 0 40px blue"}} className="interest-text">
                  {user?.interests && user.interests.trim() !== ""
                    ? user.interests
                    : "No interests added"}
                </span>
              </p>

              {user?.about && (
                <div style={{marginTop:8}}>
                  <button onClick={() => setShowAboutModal(true)} style={{"margin-bottom": "10px", padding:'6px 10px',"borderRadius":"12px", "background-color": "#494949", "color":"white", "font-weight": "bolder"}}>See About</button>
                </div>
              )}

              <button style={{"borderRadius":"12px", "background-color": "#494949", "color":"white", "font-weight": "bolder"}} onClick={startEditing}>
                Edit Profile
              </button>
            </>
          )}

          {showAboutModal && (
            <div style={{position:'fixed',left:0,top:0,right:0,bottom:0,background:'rgba(0,0,0,0.4)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:2000}} onClick={() => setShowAboutModal(false)}>
              <div onClick={(e)=>e.stopPropagation()} style={{background:'var(--surface)',color:'var(--text)',padding:20,borderRadius:8,maxWidth:'90%',maxHeight:'80%',overflowY:'auto'}}>
                <h3>About</h3>
                <div style={{whiteSpace:'pre-wrap',lineHeight:1.5}}>{user.about}</div>
                <div style={{textAlign:'right',marginTop:12}}>
                  <button onClick={() => setShowAboutModal(false)} style={{padding:'6px 10px',"borderRadius": "12px",color:'var(--text)', "background-color": "#830a0a"}}>Close</button>
                </div>
              </div>
            </div>
          )}

          <div className="profile-stats">
            <div className="stat">
              <span className="stat-num">{pic ? pic.length : "0"}</span>
              <span className="stat-label">posts</span>
            </div>
            <div className="stat" style={{cursor:'pointer'}} onClick={() => setShowFollowersModal(true)}>
              <span className="stat-num">{formatFollowerCount(user.followers ? user.followers.length : 0)}</span>
              <span className="stat-label">followers</span>
            </div>
            <div className="stat" style={{cursor:'pointer'}} onClick={() => setShowFollowingModal(true)}>
              <span className="stat-num">{formatFollowerCount(user.following ? user.following.length : 0)}</span>
              <span className="stat-label">following</span>
            </div>
          </div>
        </div>
      </div>

      <hr
        style={{
          width: "90%",
          opacity: "0.8",
          margin: "25px auto",
        }}
      />

      <div className="gallery">
        {pic.map((p) => {
          if (!p) return null;
          const hasMedia = p.media && p.media.length > 0;
          let preview = null;
          if (hasMedia) {
            const m = p.media[0];
              if (m.type === 'image') {
                preview = <img src={m.url} className='item thumbnail-img' alt="" onError={(e)=>{ /* nothing */ }} />;
              } else if (m.type === 'video') {
                if (m.thumbnail) {
                  preview = (
                    <div style={{position:'relative', display:'inline-block', width: '100%'}}>
                      <img src={m.thumbnail} alt="" className='item thumbnail-img' onError={(e)=>{ if (m.url) e.currentTarget.src = m.url; }} />
                      <div className='thumbnail-overlay'>▶</div>
                    </div>
                  );
                } else {
                  preview = (
                    <div style={{position:'relative', display:'inline-block', width:'100%'}}>
                      <video src={m.url} className='item' muted playsInline preload='metadata' style={{width:'100%',height:'auto'}} />
                      <div className='thumbnail-overlay'>▶</div>
                    </div>
                  );
                }
            }
          } else if (p.photo) {
            preview = <img src={p.photo} alt="" className="item" />;
          }
          return (
            <div key={p._id} style={{width:'33%', textAlign:'center', display:'inline-block'}} onClick={() => toggleDetails(p)}>
              {preview}
            </div>
          );
        })}
      </div>

      {show && selectedPost && (
        <PostDetail
          item={selectedPost}
          toggleDetails={toggleDetails}
        />
      )}

      {changePic && (
        <ProfilePic changeprofile={changeprofile} />
      )}

      {showFollowersModal && (
        <FollowersModal userId={user._id} onClose={() => setShowFollowersModal(false)} />
      )}

      {showFollowingModal && (
        <FollowingModal userId={user._id} onClose={() => setShowFollowingModal(false)} />
      )}
    </div>
  );
}


